import { HttpHeaders, HttpResponse } from "@angular/common/http";
import { BdpkConfigService } from "../../bdpk-common/services/bdpk-config.service";
import { DxObjectMapper } from "../../dx-core/services/dx-object-mapper.service";
import { DxHttpDispatcher } from "../../dx-core/services/dx-http-dispatcher.service";
import { map, take } from "rxjs/operators";
import { PitResponsibleUser } from "../domain/pit-responsible-user";
import * as i0 from "@angular/core";
import * as i1 from "../../bdpk-common/services/bdpk-config.service";
import * as i2 from "../../dx-core/services/dx-object-mapper.service";
import * as i3 from "../../dx-core/services/dx-http-dispatcher.service";
/**
 *  Service corresponding with responsibles-service server endpoint
 */
export class PitResponsiblesService {
    constructor(_configService, _mapper, _http) {
        this._configService = _configService;
        this._mapper = _mapper;
        this._http = _http;
        this.rsOptions = {
            headers: new HttpHeaders().set('Content-Type', 'application/json;charset=utf-8'),
            observe: "response",
            withCredentials: true
        };
        this.rsContext = this._configService.pitBackendResponsiblesEndPoint;
    }
    create(objectId, objectTypeId) {
        return this._http.post(`${this.rsContext}/object/${objectId}/type/${objectTypeId}`, null, this.rsOptions)
            .pipe(take(1), map((response) => {
            response.body.responsibleUsers = this._mapper.deserializeASArray(response.body.responsibleUsers, PitResponsibleUser);
            return response.body;
        }));
    }
    getAll(objectId, objectTypeId) {
        return this._http.get(`${this.rsContext}/object/${objectId}/type/${objectTypeId}`, this.rsOptions)
            .pipe(take(1), map((response) => {
            if (response.body)
                response.body.responsibleUsers = this._mapper.deserializeASArray(response.body.responsibleUsers, PitResponsibleUser);
            return response.body;
        }));
    }
    updateEntry(objectId, objectTypeId, respUser) {
        const body = this._mapper.serialize(respUser, PitResponsibleUser);
        return this._http.put(`${this.rsContext}/object/${objectId}/type/${objectTypeId}/resuser/${respUser.id}`, body, this.rsOptions)
            .pipe(take(1), map((response) => {
            response.body.responsibleUsers = this._mapper.deserializeASArray(response.body.responsibleUsers, PitResponsibleUser);
            return response.body;
        }));
    }
}
PitResponsiblesService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function PitResponsiblesService_Factory() { return new PitResponsiblesService(i0.ɵɵinject(i1.BdpkConfigService), i0.ɵɵinject(i2.DxObjectMapper), i0.ɵɵinject(i3.DxHttpDispatcher)); }, token: PitResponsiblesService, providedIn: "root" });
